// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.turing-ui-v2-next_mcq_modal .ant-modal-close-x {
  display: none !important;
}

.turing-ui-v2-next_mcq_modal .ant-modal-body {
  padding: 40px !important;
}

.turing-ui-v2-next_mcq_modal .ant-btn-primary {
  background: #2E6EDF;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
}

.skip-btn {
  margin-left: 8px;
}

.turing-ui-v2-next-mcq-modal-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #212121;
  margin-bottom: 8px;
}

.turing-ui-v2-next-mcq-modal-description {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #212121;
  margin-bottom: 16px;
}

.turing-ui-v2-next-mcq-card {
  background: #FFFFFF;
  border: 1px solid #E9E9E9;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 18px 16px 18px;
  margin-bottom: 32px;
}

.turing-ui-v2-next-mcq-card-icon {
  width: 60px;
  height: 60px;
  margin-right: 18px;
}

.turing-ui-v2-next-mcq-card-icon img {
  width: 60px;
  height: 60px;
}

.turing-ui-v2-next-mcq-card-category {
  font-size: 10px;
  line-height: 12px;
  color: #888888;
  margin-bottom: 4px;
}

.turing-ui-v2-next-mcq-card-challenge_name {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #212121;
  margin-bottom: 4px;
}
.turing-ui-v2-next-mcq-duration {
  font-size: 14px;
  line-height: 16px;
  color: #AAAAAA;
}

.turing-ui-v2-next-mcq-next-icon {
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.turing-ui-v2-next-mcq-suggestion {
  margin-left: 24px;
  margin-top: 29px;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.1px;
  color: #888888;
}

.turing-ui-v2-next-mcq-suggestion .turing-ui-v2-next-suggest {
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/tests/Modals/TakeNextMCQV2.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B;AACF","sourcesContent":[".turing-ui-v2-next_mcq_modal .ant-modal-close-x {\n  display: none !important;\n}\n\n.turing-ui-v2-next_mcq_modal .ant-modal-body {\n  padding: 40px !important;\n}\n\n.turing-ui-v2-next_mcq_modal .ant-btn-primary {\n  background: #2E6EDF;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 140%;\n}\n\n.skip-btn {\n  margin-left: 8px;\n}\n\n.turing-ui-v2-next-mcq-modal-title {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 23px;\n  color: #212121;\n  margin-bottom: 8px;\n}\n\n.turing-ui-v2-next-mcq-modal-description {\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.1px;\n  color: #212121;\n  margin-bottom: 16px;\n}\n\n.turing-ui-v2-next-mcq-card {\n  background: #FFFFFF;\n  border: 1px solid #E9E9E9;\n  box-sizing: border-box;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);\n  border-radius: 4px;\n  padding: 18px 16px 18px;\n  margin-bottom: 32px;\n}\n\n.turing-ui-v2-next-mcq-card-icon {\n  width: 60px;\n  height: 60px;\n  margin-right: 18px;\n}\n\n.turing-ui-v2-next-mcq-card-icon img {\n  width: 60px;\n  height: 60px;\n}\n\n.turing-ui-v2-next-mcq-card-category {\n  font-size: 10px;\n  line-height: 12px;\n  color: #888888;\n  margin-bottom: 4px;\n}\n\n.turing-ui-v2-next-mcq-card-challenge_name {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  color: #212121;\n  margin-bottom: 4px;\n}\n.turing-ui-v2-next-mcq-duration {\n  font-size: 14px;\n  line-height: 16px;\n  color: #AAAAAA;\n}\n\n.turing-ui-v2-next-mcq-next-icon {\n  margin-left: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.turing-ui-v2-next-mcq-suggestion {\n  margin-left: 24px;\n  margin-top: 29px;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.1px;\n  color: #888888;\n}\n\n.turing-ui-v2-next-mcq-suggestion .turing-ui-v2-next-suggest {\n  font-weight: 500;\n  text-decoration: underline;\n  cursor: pointer\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
